
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  BarChart3, 
  CalendarDays, 
  Calendar, 
  TrendingUp,
  ExternalLink
} from 'lucide-react';

interface Metric {
  title: string;
  description: string;
  value: number | null;
  icon: string;
  color: string;
  onClick?: () => void;
  policies?: any[];
}

interface MetricItemProps {
  metric: Metric;
  value: string;
  isLoading: boolean;
}

export const MetricItem: React.FC<MetricItemProps> = ({ metric, value, isLoading }) => {
  const getIcon = () => {
    switch (metric.icon) {
      case 'daily':
        return <CalendarDays className="w-6 h-6 text-white" />;
      case 'weekly':
        return <Calendar className="w-6 h-6 text-white" />;
      case 'monthly':
        return <BarChart3 className="w-6 h-6 text-white" />;
      case 'yearly':
        return <TrendingUp className="w-6 h-6 text-white" />;
      default:
        return <BarChart3 className="w-6 h-6 text-white" />;
    }
  };

  return (
    <Card
      className="overflow-hidden cursor-pointer transition-all duration-300 
                 bg-gradient-to-br from-white via-[#F7F5FF] to-[#E5DEFF]/80 
                 hover:shadow-lg border-purple-100 
                 transform hover:scale-[1.02] hover:-translate-y-1"
      onClick={metric.onClick}
    >
      <CardContent className="p-0">
        <div className="flex items-center">
          <div className={`${metric.color} p-4 flex items-center justify-center`}>
            {getIcon()}
          </div>
          <div className="p-4 flex-1">
            <h3 className="font-medium text-sm text-gray-700">{metric.title}</h3>
            <p className="text-xs text-gray-500">{metric.description}</p>
            {isLoading ? (
              <div className="h-6 w-24 bg-gray-200 animate-pulse rounded mt-1"></div>
            ) : (
              <div className="flex items-center">
                <p className="font-bold text-xl mr-2 text-purple-700">{value}</p>
                <ExternalLink size={16} className="text-purple-600 hover:text-purple-800" />
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
